export default __webpack_public_path__ + "static/media/img-upload-remove.64c07b2c.svg";